export enum JobType {
    IMPORT = 'IMPORT',
    EXPORT = 'EXPORT',
    DOMESTIC = 'DOMESTIC',
    REPOSITION = 'REPOSITION',
    RELOCATION = 'RELOCATION',
    REMOVAL = 'REMOVAL',
    DISTRIBUTION = 'DISTRIBUTION'
}
